import {
  PageContainer,
  PageHeader,
  PageInfoTooltip,
  PageTitle,
  PageTitleGroup,
  WorkflowsPanel,
} from "../shared";

/**
 * Workflows admin page (EN-5167), migrated from the Retool Workflows app.
 *
 * `page_Workflows` was a thin wrapper around `moduleWorkflows` with
 * `patientId` left blank — so the page is a thin wrapper around
 * `WorkflowsPanel` with no patient filter, and the module stays embeddable
 * for the Patients tickets.
 */
export function AdminWorkflows() {
  document.title = "Workflows - Admin";

  return (
    <PageContainer>
      <PageHeader>
        <PageTitleGroup>
          <PageTitle>Workflows</PageTitle>
          <PageInfoTooltip title="Workflows">
            Workflows that have triggered for a patient, and what ran on each.
            Open a row to see the patient&apos;s runs and the steps of any one
            of them. Workflows themselves are authored elsewhere — this view is
            read-only.
          </PageInfoTooltip>
        </PageTitleGroup>
      </PageHeader>

      <WorkflowsPanel />
    </PageContainer>
  );
}
